import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { SelfServeSignupPageCompletedEventTracking } from '@/modules/auth/models/segmentevents/SelfServeSignupPageCompletedEventTracking';

export class OnboardingWelcomePageCompletedEventTracking extends SelfServeSignupPageCompletedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ONBOARDING_WELCOME_PAGE_COMPLETED;
}
